import { createStyles } from "antd-style";
const useStyles = createStyles(() => ({
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%"
  },
  title: {
    fontWeight: 500,
    fontSize: 16
  }
}));
var style_default = useStyles;
export {
  style_default as default
};
